import React, { PropTypes, Component } from 'react';
import { toJS, autorun } from 'mobx';
import { autobind } from 'core-decorators';
import { ProgressState, Ticon } from '../../../../index';
import SearchPlan from '../component/SearchPlan';
import './SearchPage.less';
import tools from '../../../../utils/tools';
var mobx = require('mobx');
import { TopNavPage } from 'mutants-mobile-navigator';
import stores from '../../../stores';
import SearchPageView from '../view/SearchPageView';
const { queryStore } = stores;

@TopNavPage
class MobileReportSearchPage extends Component {

  navTitle() {
    return '高级查询';
  }


  navBack() {
    return true;
  }

  navLeftClick() {
    if (this.isKeyboard) {
      return false;
    }
    this.pop();
  }

  navRightContent() {
    return (
      <div className='navRight'>
        <div onClick={this.setting}>
          <Ticon type='shaixuan1' ></Ticon>
        </div>
      </div>
    )
  }

  setting = () => {
    if (queryStore.searchModel.info.items) {
      this.pushForResult('/querySchemeSetting', { planInfo: queryStore.searchModel.info, hiddenItems: queryStore.searchModel.hiddenItems })
    }
  }

  constructor(props) {
    super(props);
  }


  pageBackReceiveResult(result, params) {
    if (this.refs.searchPageView) {
      this.refs.searchPageView.pageBackReceiveResult(result, params);
    }
  }

  goBack = (e) => {
    tools.preventEvent(e);
    this.popAndReturn('cancel');
  }

  reset = (e) => {
    tools.preventEvent(e);
    console.log('重置');
    this.refs.searchPageView.reset();
  }

  save = (e) => {
    tools.preventEvent(e);
    this.refs.searchPageView.save();
  }

  clearError = () => {
    queryStore.searchModel.clearError();
  }

  render() {
    return (<div className='mobileSearch'>
      <SearchPageView ref='searchPageView' {...this.pageParam()} />
      <div className='footer'>
        <div className='cancel' onClick={this.reset}>重置</div>
        <div className='ok' onClick={this.save}>确定</div>
      </div>
    </div>)
  }
}

export default MobileReportSearchPage;
